import { jsxs as v, jsx as l } from "react/jsx-runtime";
import { E as a, S as m } from "./icons.types-0722eef5.js";
function g({ title: r, titleId: s, size: h, width: n, height: o, extended: c = !1, ...e }) {
  const i = c ? a : m, t = h ? i[h] : n || i[c ? "s" : "l"], d = h ? i[h] : o || i[c ? "s" : "l"];
  return /* @__PURE__ */ v(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: d,
      "aria-labelledby": s,
      ...e,
      children: [
        r ? /* @__PURE__ */ l("title", { id: s, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#CSV_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m43.928 1.5 19.711 19.712.005 49.288H14.355V63h4.928v2.567h39.433V26.145H39V6.428H19.283V34.5h-4.928v-33h29.573ZM54 37.502V60H9V37.502h45ZM51 40.5H12V57h39V40.5Zm-28.955 2.205c1.695 0 3.015.495 4.02 1.455l-1.095 1.095c-.765-.705-1.725-1.095-2.94-1.095-2.73 0-4.08 1.44-4.08 4.29 0 2.805 1.245 4.29 4.095 4.29 1.605 0 2.355-.51 3.015-1.14l1.08 1.035c-.795.795-1.92 1.53-4.17 1.53-3.855 0-5.55-1.995-5.55-5.73 0-3.915 2.055-5.73 5.625-5.73Zm9.643 0c1.875 0 3.165.435 4.05 1.02l-.825 1.245c-.765-.51-1.98-.87-3.225-.87-1.92 0-2.67.495-2.67 1.665 0 1.26 1.095 1.5 3.015 1.83 2.49.42 4.26.795 4.26 3.21 0 2.22-1.365 3.345-4.575 3.345-1.815 0-3.405-.39-4.785-1.32l.765-1.17c1.29.84 2.625 1.155 3.975 1.155 2.265 0 3.12-.585 3.12-1.935 0-1.38-1.215-1.605-3.135-1.92-2.55-.42-4.14-.855-4.14-3.165 0-2.235 1.395-3.09 4.17-3.09Zm6.434.18 3.63 9.285 3.6-9.285h1.59l-4.44 11.19h-1.545l-4.425-11.19h1.59Zm5.806-34.416v12.743h12.747L43.928 8.469Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "CSV_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as Csv
};
